import type { ReactNode } from 'react';
import type { Size2MixTabItem } from './types';

export interface Size2MixTabsProps<Id extends string> {
    tabs: readonly Size2MixTabItem<Id>[];
    activeId: Id;
    onChange: (id: Id) => void;
    ariaLabel?: string;
    /** Right-aligned content in the tab row (e.g. "Créer un nouveau planning"). */
    actions?: ReactNode;
}

/**
 * FDS tabs (`.nj-tab__items` / `.nj-tab__item`) as rendered at the very top of Nemo network sub-pages
 * (Topologie, Production, Plannings, Optimisation detail). No page title above them.
 */
export function Size2MixTabs<Id extends string>({ tabs, activeId, onChange, ariaLabel = 'Onglets', actions }: Size2MixTabsProps<Id>) {
    return (
        <div className="nj-tab" style={{ flexShrink: 0 }}>
            <div className="nj-tab__items" role="tablist" aria-label={ariaLabel} style={{ display: 'flex', alignItems: 'stretch' }}>
                {tabs.map((tab) => {
                    const isActive = tab.id === activeId;
                    return (
                        <button
                            key={tab.id}
                            type="button"
                            role="tab"
                            aria-selected={isActive}
                            disabled={tab.isDisabled}
                            tabIndex={isActive ? 0 : -1}
                            className={`nj-tab__item${isActive ? ' nj-tab__item--active' : ''}`}
                            onClick={() => onChange(tab.id)}
                        >
                            {tab.label}
                        </button>
                    );
                })}
                {actions && <div style={{ marginLeft: 'auto', paddingRight: 16, display: 'flex', alignItems: 'center', gap: 8 }}>{actions}</div>}
            </div>
        </div>
    );
}
